<template>
  <div>
    <HiloButton styleType="back" />
    <div class="squawk-content">
      <div class="title-and-aircraft">
        <p class="squawk-title">Aircraft Discrepancy Squawk</p>
        <span class="aircraft-name">Piper PA-28-151</span>
      </div>
      <p class="instructions">
        Instructions: This form is to be filled out anytime a discrepancy is
        noted.
      </p>
      <div class="input-container">
        <div class="input-section">
          <div class="input-group pilot-name" v-if="user">
            <div style="margin: 0; font-size: 22px">
              Name:
              <span style="text-align: center; width: 100%"
                >{{ user.firstName }} {{ user.lastName }}</span
              >
            </div>
          </div>
          <div class="input-group tail-number">
            <div class="input-label-container">
              <label for="tailNumberData">Tail #:</label>
              <select
                class="priority-select"
                id="tailNumberData"
                v-model="tailNumberData"
                :disabled="viewDisabled || updateDisabled"
              >
                <option v-if="tailNumber !== 'undefined'" :value="tailNumber">
                  {{ tailNumber }}
                </option>
                <option
                  v-else
                  v-for="aircraft in aircrafts"
                  :key="aircraft.id"
                  :value="aircraft.id"
                >
                  {{ aircraft.tailNumber }}
                </option>
              </select>
            </div>
          </div>
          <div class="input-group date">
            <div class="input-label-container">
              <label for="date">Date:</label>
              <input
                type="date"
                id="date"
                v-model="currentDate"
                :disabled="viewDisabled || updateDisabled"
              />
            </div>
          </div>
        </div>
      </div>
      <!--      <div class="documentation-section">
        <p class="documentation-text">This form serves to document:</p>
        <div class="checkbox-group">
          <label
            v-for="option in documentationOptions"
            :key="option.value"
            tabindex="0"
            @keydown.space.prevent="selectOption(option.value)"
          >
            <input
              type="radio"
              v-model="documentationType"
              :value="option.value"
              tabindex="-1"
              :disabled="disabled"
            />
            {{ option.label }}
          </label>
        </div>
      </div>-->
      <div class="priority-section" v-if="adminUser">
        <p class="priority-text">Squawk Priority:</p>
        <select
          v-model="squawkPriority"
          class="priority-select"
          :disabled="viewDisabled || updateDisabled"
        >
          <option disabled value="">Select Squawk Priority</option>
          <option v-for="n in 10" :key="n" :value="n">{{ n }}</option>
        </select>
      </div>
    </div>
    <div class="squawk-content">
      <p class="squawk-title">Squawk Details</p>
      <div class="input-group">
        <label for="squawkDescription"
          >Description of Issues / Reasons for Squawk:</label
        >
        <textarea
          id="squawkDescription"
          v-model="squawkDescription"
          class="description-textarea"
          :disabled="viewDisabled || updateDisabled"
        ></textarea>
      </div>
    </div>
    <div class="squawk-content">
      <div class="priority-section">
        <p class="priority-text">Squawk Status:</p>
        <select
          v-model="squawkStatus"
          class="priority-select"
          :disabled="viewDisabled"
        >
          <option disabled value="">Select Squawk Status</option>
          <option
            v-for="status of statuses"
            :key="status.id"
            :value="status.id"
          >
            {{ status.name }}
          </option>
        </select>
      </div>
      <br />
      <p class="squawk-title">Aircraft Return to Service</p>
      <div class="input-group">
        <label for="actionsTaken">Actions Taken / Repairs Made:</label>
        <textarea
          id="actionsTaken"
          v-model="actionsTaken"
          class="description-textarea"
          :disabled="viewDisabled"
        ></textarea>
      </div>
      <div class="input-section">
        <div class="input-group combined-input">
          <p>
            Approved by: {{ approvedBy.firstName }} {{ approvedBy.lastName }}
          </p>
          <p>Cert #: {{ approvedBy.cert }}</p>
        </div>
        <div class="input-group combined-input">
          <div class="input-label-container">
            <label for="mechanicSignature">Mechanic Signature:</label>
            <input
              type="text"
              id="mechanicSignature"
              v-model="mechanicSignature"
              :disabled="viewDisabled"
            />
            <label for="mechanicDate" class="right-label">Date:</label>
            <input
              type="date"
              id="mechanicDate"
              v-model="mechanicDate"
              class="right-input"
              :disabled="viewDisabled"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <div
        v-if="
          (mechanicSignature !==
            approvedBy.firstName + ' ' + approvedBy.lastName ||
            mechanicDate > new Date().toISOString().split('T')[0] ||
            !mechanicDate) &&
          type === 'update'
        "
      >
        <p
          class="redText"
          v-if="
            mechanicSignature !==
            approvedBy.firstName + ' ' + approvedBy.lastName
          "
        >
          <i class="fa-solid fa-circle-exclamation"></i>
          Missing or invalid Signature
        </p>
        <p
          class="redText"
          v-if="
            mechanicDate > new Date().toISOString().split('T')[0] ||
            !mechanicDate
          "
        >
          <i class="fa-solid fa-circle-exclamation"></i>
          Missing or invalid Date
        </p>
      </div>
      <HiloButton label="Save" v-else-if="!viewDisabled" @click="saveSquawk" />
      <!--      <HiloButton label="Print" />-->
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { useLoginStore } from "@/stores/loginStore";
import HiloButton from "src/components/HiloComponents/HiloButton.vue";
import AircraftAPIService from "../../../../servicehandlers/AircraftAPIService";
const aircraftAPIService = new AircraftAPIService();
import SquawksAPIService from "src/servicehandlers/SquawksAPIService.js";
const squawkAPIService = new SquawksAPIService();

export default {
  components: { HiloButton },
  props: ["tailNumber"],
  data() {
    return {
      squawkID: null,
      type: null,
      adminUser: false,
      user: null,
      tailNumberData: this.tailNumber === "undefined" ? "" : this.tailNumber,
      currentDate: new Date().toISOString().split("T")[0],
      documentationType: "",
      squawkPriority: "",
      statuses: [],
      squawkStatus: "",
      squawkDescription: "",
      actionsTaken: "",
      approvedBy: "",
      certNumber: "",
      mechanicSignature: "",
      mechanicDate: null,
      aircrafts: [],
      viewDisabled: false,
      updateDisabled: false,
      documentationOptions: [
        { label: "Mechanical Issue", value: "Mechanical Issue" },
        { label: "INOP Equipment", value: "INOP Equipment" },
        { label: "Incident", value: "Incident" },
        { label: "Other", value: "Other" },
      ],
    };
  },
  created() {
    this.adminUser = useLoginStore().getUser.auth_groups.some((data) => {
      return data.name === "Admins" || data.name === "Owner";
    });
    this.type = this.$route.query.type;
    if (this.type === "new") {
      this.user = useLoginStore().getUser;
    } else if (this.type === "view") {
      this.viewDisabled = true;
      this.getSquawk(this.$route.query.id);
    } else if (this.type === "update") {
      this.updateDisabled = true;
      this.approvedBy = useLoginStore().getUser;
      this.getSquawk(this.$route.query.id);
    }
  },
  async mounted() {
    await this.getAircraft();
    this.getStatuses();
  },
  methods: {
    selectOption(option) {
      this.documentationType = option;
    },
    async getAircraft() {
      try {
        this.aircrafts = await aircraftAPIService.get(this.$router);
      } catch (error) {}
    },
    getSquawk(id) {
      return squawkAPIService.getById(id, this.$router).then((response) => {
        this.squawkID = response.id;
        this.user = response.descriptionUser;
        this.currentDate = new Date(response.descriptionDate)
          .toISOString()
          .split("T")[0];
        this.squawkDescription = response.description;
        this.actionsTaken = response.response;
        if (response.responseUser) {
          this.approvedBy = response.responseUser;
          this.certNumber = response.responseUser.cert;
          this.mechanicSignature =
            this.approvedBy.firstName + " " + this.approvedBy.lastName;
          this.mechanicDate = new Date(response.responseDate)
            .toISOString()
            .split("T")[0];
        }
        this.squawkPriority = response.priority;
        this.squawkStatus = response.squawkStatusId;
      });
    },
    getStatuses() {
      return squawkAPIService
        .getStatuses(this.$router)
        .then((response) => {
          this.statuses = response;
        })
        .catch((e) => {});
    },
    saveSquawk() {
      let temp = {
        aircraftId: this.aircrafts.find(
          (data) => data.tailNumber === this.tailNumberData,
        ).id,
        descriptionUserId: this.user.id,
        descriptionDate: this.currentDate,
        squawkStatusId: this.squawkStatus,
        description: this.squawkDescription,
        response: this.actionsTaken,
        isMechanicResponse: this.actionsTaken ? !this.adminUser : null,
        responseUserId: this.actionsTaken ? this.approvedBy.id : null,
        responseDate: this.actionsTaken ? this.mechanicDate : null,
        priority: this.squawkPriority,
      };
      if (this.type === "new") {
        return squawkAPIService.create(temp).then((response) => {
          this.navigateBack();
        });
      } else {
        return squawkAPIService.update(this.squawkID, temp).then((response) => {
          this.navigateBack();
        });
      }
    },
    navigateBack() {
      this.$router.push(
        `/hilo/aircraft/${
          this.aircrafts.find((data) => data.tailNumber === this.tailNumberData)
            .id
        }`,
      );
    },
  },
};
</script>

<style scoped>
.squawk-content {
  margin-top: 20px;
}

.title-and-aircraft {
  display: flex;
  align-items: flex-end;
}

.squawk-title {
  font-size: 24px;
  margin-bottom: 0;
  line-height: normal;
}

.aircraft-name {
  margin-left: 20px;
  font-size: 14px;
  font-weight: normal;
}

.instructions {
  font-size: 14px;
  margin-top: 0;
}

.input-container {
  display: flex;
  justify-content: left;
}

.input-section {
  display: flex;
  margin-top: 10px;
  gap: 20px;
  width: 100%;
}

.input-group {
  display: flex;
  flex-direction: column;
}

p {
  font-size: 14px;
}

.input-label-container {
  display: flex;
  align-items: center;
  position: relative;
}

.input-label-container label {
  font-size: 14px;
  position: absolute;
  left: 8px;
  padding-top: 8px;
  font-weight: normal;
}

.input-label-container input {
  padding: 4px 4px 4px 100px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f0f0f0;
  height: 31px;
  width: 100%;
}

.input-label-container select {
  padding: 4px 4px 4px 100px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f0f0f0;
  height: 31px;
}

.input-group.pilot-name {
  width: 50%;
}

.input-group.tail-number,
.input-group.date {
  width: 25%;
}

.input-group.date {
  padding-left: 0;
}

.documentation-section {
  margin-top: 20px;
}

.documentation-text {
  font-size: 16px;
  color: black;
  margin-bottom: 10px;
}

.checkbox-group {
  display: flex;
  gap: 40px;
}

.checkbox-group label {
  font-size: 16px;
  display: flex;
  align-items: center;
}

.checkbox-group input[type="radio"] {
  appearance: none;
  width: 14px;
  height: 14px;
  border: 1px solid #ccc;
  margin-right: 8px;
  display: inline-block;
  position: relative;
}

.checkbox-group input[type="radio"]:checked::before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: black;
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.priority-section {
  margin-top: 20px;
}

.priority-text {
  font-size: 16px;
  color: black;
  margin-bottom: 10px;
}

.priority-select {
  padding: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f0f0f0;
  width: calc(50% - 20px);
  height: 31px;
}

.input-group textarea.description-textarea {
  padding: 4px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f0f0f0;
  width: 100%;
  height: 100px;
  resize: vertical;
}

.input-group.combined-input {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f0f0f0;
  padding: 8px 4px 0;
  margin: 10px 0;
  height: 31px;
}

.input-group.combined-input .input-label-container {
  display: flex;
  align-items: center;
  position: relative;
}

.input-group.combined-input .input-label-container label {
  font-size: 14px;
  position: absolute;
  padding: 0 4px;
  background-color: #f0f0f0;
}

.input-group.combined-input .input-label-container .right-label {
  left: 50%;
  transform: translateX(-50%);
}

.input-group.combined-input .input-label-container input {
  padding: 0 4px 6px 200px;
  font-size: 14px;
  background-color: #f0f0f0;
  height: 20px;
  width: calc(50% - 50px);
  border: none;
}

.input-group.combined-input .input-label-container .right-input {
  width: calc(50% - 50px);
  height: 100%;
  padding: 0 4px 6px 50px;
  box-sizing: border-box;
  position: absolute;
  right: 0;
}
.button-container {
  margin-top: 20px;
  display: flex;
  gap: 10px;
}
.redText {
  color: #dc2427;
}
</style>
